import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SiteSettingsContext = createContext({});

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    site_name: '',
    logo_url: null,
    logo_link_url: null,
    home_title: '',
    home_description: '',
  });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/settings/public`);
      setSettings(prev => ({ ...prev, ...response.data }));
      if (response.data.site_name) {
        document.title = response.data.site_name;
      }
    } catch (error) {
      console.error('Error loading site settings:', error);
    } finally {
      setLoaded(true);
    }
  };

  const refreshSettings = () => loadSettings();

  return (
    <SiteSettingsContext.Provider value={{ ...settings, loaded, refreshSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
